import axios from 'axios';
import TomSelect from 'tom-select';

declare let booking_object: any;

export default class roomPlayersRange{

    public control: TomSelect | null = null;

    /**
     * Initializes the TomSelect control once.
     */
    initialize(selector: string) {
        
        const element = document.querySelector(selector) as HTMLSelectElement;

        if(!element){

            console.error(`Players selector "${selector}" not found.`);
            return;

        }

        if((element as any).tomselect){

            this.control = (element as any).tomselect;
            return;

        }

        const settings = {
            plugins: ['dropdown_input'],
            valueField: 'value',
            labelField: 'text',
            searchField: ['text'],
            preload: true,
            render: {
                option: (item: any, escape: any) => `<span class="block w-full fluid-text-xs">${escape(item.text)}</span>`,
                item: (item: any, escape: any) => `<span>${escape(item.text)}</span>`,
            }
        };

        this.control = new TomSelect(element, settings);
        this.control.disable();

    }

    /**
     * Loads or reloads data into the existing TomSelect control.
     */
    load(room_id: string): Promise<number | null> {

        return new Promise(async (resolve, reject) => {

            // This check prevents errors if initialize() failed
            if (!this.control) {

                return reject(new Error("TomSelect for players is not initialized. Call initialize() first."));

            }

            // The code flow is now linear, so TypeScript knows this.control is not null
            this.control.clear();
            this.control.clearOptions();
            this.control.enable();

            try{
                
                const post_data = { 'room_id': room_id };
                const queryString = new URLSearchParams(post_data).toString();
                
                // We await the result of the axios call
                const response = await axios.post(booking_object.rest_urls.get_room_players_range, queryString);
                
                const playersArray: number[] = response.data.data;

                if(Array.isArray(playersArray) && playersArray.length > 0){

                    const formattedData = playersArray.map(num => ({ value: num, text: String(num) }));
                    this.control.addOptions(formattedData);
                    const first_value = formattedData[0].value;
                    this.control.setValue(String(first_value));

                    resolve(first_value);

                }else{

                    const placeholder = { value: '', text: booking_object.general_message.no_players_available };
                    this.control.addOption(placeholder);
                    this.control.setValue(placeholder.value);
                    this.control.disable();
                    resolve(null);

                }

            }catch(error){

                // Any error from the 'await' call will be caught here
                if(this.control){

                    this.control.disable();

                }

                reject(error);

            }

        });

    }

    /**
     * Populates the TomSelect control with data.
     * @param playersData 
     * @returns 
     */
    populate(playersData: number[]): number | null {

        if(!this.control){
            
            return null;
        }

        this.control.clear();
        this.control.clearOptions();
        this.control.enable();

        if(playersData && playersData.length > 0){

            const formattedData = playersData.map(num => ({ value: num, text: String(num) }));
            this.control.addOptions(formattedData);
            const first_value = formattedData[0].value;
            this.control.setValue(String(first_value));
            return first_value;

        }else{

            const placeholder = { value: '', text: booking_object.general_message.no_players_available };
            this.control.addOption(placeholder);
            this.control.setValue(placeholder.value);
            this.control.disable();
            return null;

        }

    }

}